angular.module('charts')
    .directive('dblExpandableStandardsList', [function() {

    return {
        restrict: 'E',
        scope: {
            dblStandards: '=',
            dblShowClusterLabels: '='
        },
        templateUrl: '/resources/charts/directives/expandable-standards-list/dbl-expandable-standards-list.directive.html',
        controller: ['$filter', '$scope', function ($filter, $scope) {

            function getAstName () {
                if (!$scope.dblStandards) {
                    return '';
                }

                // First look for AST name on standards object
                if ($scope.dblStandards.astName) {
                    return $scope.dblStandards.astName;
                }

                // Currently don't get AST name on some standards results, so try to infer from label
                // TODO: this is brittle; add AST to standards result
                if ($scope.dblStandards.standards && $scope.dblStandards.standards.length > 0) {
                    var firstStandard = $scope.dblStandards.standards[0];
                    if (firstStandard.label.indexOf('.') === -1) {
                        return 'dbl';
                    }
                }

                return '';
            }

            $scope.getStandardsText = function () {
                if (!$scope.dblStandards || !$scope.dblStandards.standards) {
                    return;
                }

                var astName = getAstName();
                var standardText = $filter('translate')('shared.labels.' + ($scope.dblStandards.standards.length === 1 ? 'standard' : 'standards'));
                var message = $scope.dblStandards.standards.length + ' ' + $filter('domainText')(standardText, astName);

                return message;
            };
        }]
    };
}]);
